// extracted by mini-css-extract-plugin
export default {"backButton":"_7qHy6hf9htP3VI0V7scCjA=="};